import React from 'react'
import AnalyzerCategoriesTable from './Table'
import { useSignal } from '@preact/signals-react'
import { AppModal } from '@components'



export default function AnalyzerCategories({ tableData, evolutionData, xList  }) {

	const isFullScreen = useSignal(false)

	return <>
		<AnalyzerCategoriesTable tableData={tableData} setFullScreen={() => isFullScreen.value = !isFullScreen.value} evolutionData={evolutionData} xList={xList} isFullScreen={isFullScreen.value} />
		<AppModal
			isOpen={isFullScreen.value}
			controller={() => isFullScreen.value = false}
			title="Price Table sorted by Categories"
			icon="layer-group"
			containerProps={{ fullScreen: true, sx: { '.MuiDialogContent-root': { px: 3, pt: 0, pb: 2 }, '.MuiDialogContent-root .MuiCard-root': { border: 'none', boxShadow: 'none', borderRadius: 0 } }}}
			hideActions>
			<AnalyzerCategoriesTable
				tableSx={{
					sx: {
						height: '100%',
						maxHeight: '100%',
					}
				}}
				tableData={tableData}
				setFullScreen={() => isFullScreen.value = !isFullScreen.value}
				evolutionData={evolutionData}
				xList={xList}
				isFullScreen={isFullScreen.value} />
		</AppModal>
	</>
}